import React, { Component } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './miniCard.css';
import Kakashi from './Kakashi.gif';
import contactData from './contactData.json';

export default class Contact extends Component {
  render() {
    return (
      <span>
        <b id='contact' className='TitleEmphasis'><box-icon name='message-dots' animation='tada' ></box-icon> Let's Connect</b>
        <p style={{ color: 'gray', fontWeight: 'bold' }}>———————— Got ideas ? Let's Connect ————————</p>
        <Container className='d-flex justify-content-center'>
          <Row className='col-lg-12 col-md-12 col-sm-11 d-flex justify-content-center'>
            <Col style={{
              backgroundImage: `url(${Kakashi})`,
              borderRadius: '1rem',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }} className='col-lg-6 col-md-4 col-12 justify-content-center d-flex'>
              <h2 style={{ backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', margin: 'auto', paddingLeft: '2rem', paddingRight: '2rem', paddingTop: '0.5rem', paddingBottom: '0.5rem', borderRadius: '1rem' }}> Here's how you may reach out to me <i class="uil uil-message"></i></h2>
            </Col>
            <Col className='col-lg-6 col-md-8 d-flex flex-column align-items-center justify-content-center'>
              {contactData.map((contactItem) => (
                <button
                  key={contactItem.id}
                  onClick={() => window.open(contactItem.link)}
                  className='col-10'
                  style={{ backgroundColor: 'grey', color: 'white', fontSize: '1rem', margin: '0.25rem', padding: '0.25rem', borderRadius: '1rem' }}
                >
                  <b>{contactItem.title} <i className={contactItem.icon}></i></b><br />
                  {contactItem.subtitle}<br />
                  <b>{contactItem.action}</b>
                </button>
              ))}
            </Col>
          </Row>
        </Container>
      </span>
    )
  }
}
